import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserInfo } from 'os';
import { LoginUserModel } from '../models/loginUserModel';
import { jwtDecode } from 'jwt-decode';
import { Observable } from 'rxjs';
import { Device } from '../models/device';
import { DriverModel } from '../models/DriverModel';
import { GroupModel } from '../models/GroupModel';

@Injectable({
  providedIn: 'root'
})
export class DevicesService {
  url = environment.apiUrl;
  data!: LoginUserModel;
  constructor(private http: HttpClient) { }


  loadDevices(clientNumber: number, userId: number, status: string, assign: boolean = false): Observable<any> {

    return this.http.get(this.url + 'Card/client?clientNumber=' + clientNumber + '&status=' + status + '&userId=' + userId + '&assign=' + assign)

  }

  loadInfoDevice(card: number, clientNumber: number): Observable<any> {

    return this.http.get(this.url + 'Card/data?clientNumber=' + clientNumber + '&cardNumber=' + card)
  }

  changeDevicesStatus(cards: any[], clientNumber: number, userName: string): Observable<any> {
    return this.http.post(this.url + 'Card/save/status', {
      cards: cards,
      clientNumber: clientNumber,
      userName: userName
    })
  }

  saveCardParams(card: Device, clientNumber: number, idUser: number, updateType: string, userName: string) {
    return this.http.post(this.url + 'Card/update', {
      card: card,
      clientNumber: clientNumber,
      userId: idUser,
      updateType: updateType,
      userName: userName
    });
  }

  getPlates(cardID: number, clientNumber: number): Observable<any> {
    return this.http.get(this.url + 'Card/Plates?clientNumber=' + clientNumber + '&cardId=' + cardID);
  }

  getPlatesTimeSpan(): Observable<any> {
    return this.http.get(this.url + 'Card/plates/updatetime');
  }

  getPhotoTypeList(): Observable<any> {
    return this.http.get(this.url + 'card/phototypes');
  }

  getPlatesByClient(clientNumber: number): Observable<any> {
    return this.http.get(this.url + 'card/plates/all?clientNumber=' + clientNumber);
  }

  addDevices(cards: Device[], clientNumber: number, userName: string): Observable<any> {
    return this.http.post(this.url + 'card/add', {
      cards: cards,
      clientNumber: clientNumber,
      userName: userName
    });
  }

  getRequests(clientNumber: number, fromDate: Date, toDate: Date): Observable<any> {
    return this.http.get(this.url + 'card/requests?clientNumber=' + clientNumber + "&fromDate=" + fromDate.toISOString() + "&toDate=" + toDate.toISOString());
  }


  getDrivers(clientNumber: number, showAll: boolean = true) {
    return this.http.get(this.url + 'driver?clientNumber=' + clientNumber + '&showAll=' + showAll);
  }

  addDriver(info: DriverModel, clientNumber: number) {
    return this.http.post(this.url + 'driver', {
      clientNumber: clientNumber,
      driver: info
    });
  }

  updateDriverQR(info: DriverModel) {
    return this.http.post(this.url + 'driver/QREnabled', info);
  }


  deleteDriver(info: DriverModel, clientNumber: number) {

    const url = `${this.url}driver`;
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        clientNumber: clientNumber,
        driver: info
      },
    };
    return this.http.delete(url, options);

  }

  deleteDrivers(info: DriverModel[], clientNumber: number): Observable<any>{

    const url = `${this.url}driver/delete/multiple`;
    return this.http.post(url, info);

  }

  sendRequestToPrint(list: Device[], clientNumber: number, userName: string): Observable<any> {
    return this.http.post(this.url + 'card/print/request', {
      cards: list,
      clientNumber: clientNumber,
      name: userName
    })
  }


  getGroups(clientId: number): Observable<any> {
    return this.http.get(this.url + 'group?clientId=' + clientId)
  }

  saveGroup(group: GroupModel, userName: string): Observable<any> {
    return this.http.post(this.url + 'group', {
      group: group,
      userName: userName
    })
  }

  deleteGroup(group: GroupModel, userName: string): Observable<any> {
    return this.http.post(this.url + 'group/delete', {
      group: group,
      userName: userName
    });
  }

  getGroupCards(clientId: number, groupId: number): Observable<any> {
    return this.http.get(this.url + 'Movements/groupInfo?clientId=' + clientId + '&groupId=' + groupId)
  }
  saveDevicesGroup(card: any[]): Observable<any[]> {
    return this.http.post<any[]>(this.url + 'Movements/group', card);
  }

  deleteDevicesGroup(data: any): Observable<any> {
    const url = `${this.url}Movements/group`;
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: data,
    };
    return this.http.request<any>('delete', url, options);
  }

  searchUsersByCard(clientNumber: number, cardId: number, showAll: boolean = true): Observable<any> {
    return this.http.get(this.url + 'card/users?clientNumber=' + clientNumber + '&card_id=' + cardId + '&showAll=' + showAll);
  }

  resendEmail(driver: any): Observable<any> {
    return this.http.post(this.url + 'driver/resend', driver)
  }


  saveDriverPhoto(driverId: number, clientNumber: number, fileId: string): Observable<any> {
    return this.http.post(this.url + 'driver/photo', { driverId, clientNumber, fileId });
  }

  getDriverPhoto(driverId: number, clientNumber: number): Observable<any> {
    return this.http.get(this.url + 'driver/photo/' + driverId + '?clientNumber=' + clientNumber);
  }

  getExpiringCards(clientNumber: number): Observable<any> {
    return this.http.get(this.url + 'Card/expiring?clientNumber=' + clientNumber);
  }

  renewCardExpiration(clientNumber: number, cardNumbers: number[]): Observable<any> {
    return this.http.post(this.url + 'Card/renew-expiration', { clientNumber, cardNumbers });
  }
}
